/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation LBRRouteCreateMutation($customerAccountId: ID!, $type: CUSTOMER_TYPE!, $displayName: String!, ) {
  LBRRouteCreate(customerAccountId: $customerAccountId,type: $type, displayName: $displayName, ) {
    message
    status
  }
}
`
